/**
 * Persiste o carrinho no localStorage a cada ação `cart/*`.
 * A leitura é feita direto no `initialState` do cartSlice (loadInitial).
 */
const STORAGE_KEY = 'ebookCart';

export const cartMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  if (typeof action?.type === 'string' && action.type.startsWith('cart/')) {
    try {
      const { items } = store.getState().cart;
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ items }));
    } catch {
      // ignora quota / SSR / modo privado
    }
  }

  return result;
};

export default cartMiddleware;
